const FETCH_INCENTIVES = 'fetch_incentives';
const FETCH_INCENTIVES_ENTITIES = 'fetch_incentives_entities';
const FETCH_INCENTIVES_CSV = 'fetch_incentives_csv';
const FETCH_INCENTIVE = 'fetch_incentive';
const FETCH_INCENTIVES_PROVIDERS = 'fetch_incentive_providers';
const FETCH_INCENTIVES_IN_FILE = 'fetch_incentives_in_file';
const DELETE_INCENTIVE = 'delete_incentive';
const PERSIST_INCENTIVE = 'persist_incentive';
const UPDATE_INCENTIVE = 'update_incentive';

export default {
    FETCH_INCENTIVES,
    FETCH_INCENTIVES_ENTITIES,
    FETCH_INCENTIVES_PROVIDERS,
    FETCH_INCENTIVES_CSV,
    FETCH_INCENTIVES_IN_FILE,
    FETCH_INCENTIVE,
    DELETE_INCENTIVE,
    PERSIST_INCENTIVE,
    UPDATE_INCENTIVE,
};
